export default "__VITE_ASSET__mAN8c4cE__"